window.NG = {};

NG.W = window;
NG.D = document;
NG.E = NG.D.documentElement;
NG.G = NG.D.getElementsByTagName('body')[0];
NG.X = NG.W.innerWidth || NG.E.clientWidth || NG.G.clientWidth;
NG.Y = NG.W.innerHeight || NG.E.clientHeight || NG.G.clientHeight;

NG.isIE10 = false;
NG.isIE11 = false;
NG.isFirefox = false;
NG.isSafari = false;

NG.tabletWidthPortrait = 768;
NG.tabletWidthLandscape = 1024;
NG.desktopWidthSmall = 1200;

NG.popup = true;

NG.paths = {
  dev: '',
  dist: ''
};



// WEBPACK FOOTER //
// src/assets/js/global.js